module.exports = __webpack_public_path__ + "static/media/cgc.28593e05.svg";